import { useRef, useState } from "react";
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from "react-icons/md";

import styles from "./Portfolio.module.css";
import { Section } from "../../layout/Section/Section";
import { PROJECTS } from "../../utils/app-content";
import { Container } from "../../layout/Container/Container";
import { SectionTitle } from "../../components/SectionTitle/SectionTitle";
import { PortfolioItem } from "../../components/PortfolioItem/PortfolioItem";
import { projectsImages } from "../../utils/projects-images";
import Arrow from "../../components/UI/Arrow/Arrow";
import UIModal from "../../components/UI/Modal/Modal";

export const Portfolio = () => {
  const [portfolioActiveIndex, setPortfolioActiveIndex] = useState(0);
  const [activeImageIndex, setActiveImageIndex] = useState(0);
  const [isImageModalVisible, setIsImageModalVisible] = useState("null");
  const currentProjectImages = useRef(projectsImages[portfolioActiveIndex]);

  const onPortfolioArrowClickHandler = (dir) => {
    const len = PROJECTS.length - 1;
    if (dir === "left")
      setPortfolioActiveIndex((prev) => (prev === 0 ? len : prev - 1));
    else setPortfolioActiveIndex((prev) => (prev === len ? 0 : prev + 1));
    setActiveImageIndex(0);
  };

  const onModalArrowClickHandler = (dir) => {
    const len = currentProjectImages.current.length - 1;
    if (dir === "left")
      setActiveImageIndex((prev) => (prev === 0 ? len : prev - 1));
    else setActiveImageIndex((prev) => (prev === len ? 0 : prev + 1));
  };

  const openModalHandler = () => {
    setIsImageModalVisible(true);
    currentProjectImages.current = projectsImages[portfolioActiveIndex];
  };

  const closeModalHandler = () => {
    setIsImageModalVisible(false);
  };

  return (
    <>
      <Section id="portfolio">
        <SectionTitle title="Portfolio" subtitle="Most recent work" />
        <Container className={`${styles.container} grid`}>
          <ul className={styles.projects}>
            {PROJECTS.map((project, idx) => (
              <PortfolioItem
                openModalHandler={openModalHandler}
                setIsImageModalVisible={setIsImageModalVisible}
                key={idx}
                portfolioActiveIndex={portfolioActiveIndex}
                project={project}
                activeImageIndex={activeImageIndex}
                setActiveImageIndex={setActiveImageIndex}
              />
            ))}
          </ul>
          <button
            aria-label="left arrow"
            className={styles.arrowL}
            onClick={() => onPortfolioArrowClickHandler("left")}
          >
            <MdKeyboardArrowLeft className={styles.icon} />
          </button>
          <button
            aria-label="right arrow"
            className={styles.arrowR}
            onClick={() => onPortfolioArrowClickHandler("right")}
          >
            <MdKeyboardArrowRight className={styles.icon} />
          </button>
        </Container>
      </Section>

      <UIModal
        header={""}
        isImage={true}
        body={
          <ImageSliderModal
            activeImageIndex={activeImageIndex}
            currentProjectImages={currentProjectImages}
            onModalArrowClickHandler={onModalArrowClickHandler}
          />
        }
        isOpen={isImageModalVisible}
        closeModal={closeModalHandler}
      />
    </>
  );
};

const ImageSliderModal = ({
  currentProjectImages,
  onModalArrowClickHandler,
  activeImageIndex,
}) => {
  return (
    <div className={styles["modal-slider-container"]}>
      <div className={styles["images-slider-container"]}>
        {currentProjectImages.current.map((item, index) => (
          <div
            key={index}
            style={{ opacity: activeImageIndex === index ? 1 : 0 }}
            className={`${styles["image-slider-item-container"]}`}
          >
            <img src={item} alt={"image"} />
          </div>
        ))}
      </div>
      <div className={styles["images-slider-footer-container"]}>
        <Arrow
          arrowDirection="left"
          onClick={onModalArrowClickHandler}
          style={{ position: "static" }}
        />
        <p style={{ width: "60px", textAlign: "center" }}>
          {activeImageIndex + 1} / {currentProjectImages.current.length}
        </p>
        <Arrow
          arrowDirection="right"
          onClick={onModalArrowClickHandler}
          style={{ position: "static" }}
        />
      </div>
    </div>
  );
};
